<template>
  <Listbox as="div" v-model="model">
    <ListboxLabel class="block text-sm font-medium leading-6 text-gray-900 mb-2" :for='labelId' v-if='!props.hideLabel' :class='[props.srLabel ? "sr-only" : ""]'>{{ props.label }}</ListboxLabel>
    <div class="relative">
      <ListboxButton :id='labelId' class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-jananavy-600 sm:text-sm sm:leading-6">
        <span class="block truncate">{{ selected?.label }}</span>
        <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <ChevronUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>
      <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <ListboxOptions class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
          <ListboxOption as="template" v-for="option in props.options" :key="option.value" :value="option.value" v-slot="{ active, model }">
            <li :class="[active ? 'bg-jananavy-900 text-white' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9']">
              <span :class="[active ? 'font-semibold' : 'font-normal', 'block truncate']">{{ option.label }}</span>
              <span v-if="active" :class="[active ? 'text-white' : 'text-jananavy-900', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                <CheckIcon class="h-5 w-5" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script setup>
  
import { nanoid } from 'nanoid';

import { computed } from 'vue';
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/20/solid';

const props = defineProps({
  label: String,
  options: Array,
  hideLabel: Boolean,
  srLabel: Boolean,
  labelId: String
});

const model = defineModel();

const selected = computed(() => {
  return props.options.find(option => option.value === model.value);
});

const labelId = computed(() => {
  return props.labelId || nanoid();
});

</script>